import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, NavLink, useNavigate } from "react-router-dom";

// import logo from "../../images/logo-full.png";
import logo from "../../icons/photos/chillLogo.png";
import bgimage from "../../images/login-img/pic-5.jpg";
import { authenticate } from "../../feature/authSlice";
import EmailPhoneCombine from "../../jsx/components/fields/emailPhoneField";
import PasswordField from "../../jsx/components/fields/passwordField";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import outerPhoto from "../../icons/photos/loginPagePhoto.png";
import outerMainBannerImg from "../../media/images/authAssets/outerMainBannerImg.png";
// import splashImg from "../../media/images/authAssets/splashImg.png";
import splashImg from "../../media/images/authAssets/splashImg.jpeg";
import splashImg2 from "../../media/images/authAssets/splashImg2.png";
import { requestForToken } from "../../firebase";
import "./auth.scss";
import {
  emailValidation,
  noSpaceOnChange,
  passwordValidation,
  phoneValidation,
} from "../../validations/validation";
import { setIsSignUpFlagTrue, setUserDetails } from "../../feature/userData/userData";
import { checkCredentials } from "../../service/api/user/login";
import {
  btnCustomer,
  btnNotUser,
  btnProfessional,
  btnResendCode,
  btnSignUp,
  hintEnterValidationCode,
  lblLoginTitle,
  lblOr,
  lblPassword,
  lblSignInAs,
  lblSignUpIn,
  lbsSignInAs,
  txtANewWay,
  txtForgotPassword,
  txtNeedHelp,
  txtSignUpAs,
  txtWelcome,
} from "../../dataBaseFile/label";
import {
  errEmptyEmailOrPhone,
  errEmptyPassword,
  validEmail_OR_MobileNumberText,
  validPassword,
} from "../../dataBaseFile/error";
import { resendCode } from "../../service/api/user/resendActivationCode";
import PasswordChecker from "../../component/passwordChecker/passwordChecker";
import { btnForgotPassword, btnLogin } from "../../dataBaseFile/alert";
import { LoginSocialApple, LoginSocialFacebook } from "reactjs-social-login";
import {
  AppleLoginButton,
  FacebookLoginButton,
} from "react-social-login-buttons";

import { GoogleLogin, useGoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import { registerUserViaThirdPartyApp } from "../../service/api/user/registerUserViaThirdPartyApp";
import { Button, Modal, Spinner } from "react-bootstrap";

import proIcon from "../../media/images/pro-icon.png";
import custIcon from "../../media/images/customer-icon.png";
import googleIcon from "../../media/images/google_logo.png";
import facebookIcon from "../../media/images/facebook_logo.webp";
import appleIcon from "../../media/images/apple_logo.png";
import { loginHeading } from "./text";

import axios from "axios";
import TextField from "../../jsx/components/fields/textFieldNew";
import { accountExistenceCheckApi } from "../../service/api/user/checkAccountExistence";
import { FaEdit } from "react-icons/fa";
import VerifyComponent from "./verifyComponent";
import { useLocation } from "react-router-dom";
import { formatPhoneNumber } from "../../functions/validations";
import customerImg from "../../media/images/authAssets/customerImg.png";
import proImg from "../../media/images/authAssets/proImg.png";
import proTeamImg from "../../media/images/authAssets/proTeamImg.png";
import FeedbackModal from "../../jsx/components/feedback/feedback";
import InputField from "../../jsx/components/fields/inputField";
import { loginViaOTPApi } from "../../service/api/user/loginViaOTP";


export default function Login({ onhandleSignUp }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [isEmailPhoneVal, setIsEmailPhoneVal] = useState(false);
  const [emailPhoneValue, setEmailPhoneValue] = useState("");
  const [codeValue, setCodeValue] = useState(1);
  const [isPhone, setIsPhone] = useState(false);
  const [isPassword, setIsPassword] = useState(false);
  const [inputTypeOfPassword, setInputTypeOfPassword] = useState(true);
  const [loaderActive, setLoaderActive] = useState(false);
  const [showPassVal, setShowPassVal] = useState(false);

  const [loginErrorMsg, setLoginErrorMsg] = useState("");
  const [passwordErrorMsg, setPasswordErrorMsg] = useState("");
  const [isFocused, setIsFocused] = useState(false);

  const [role, setRole] = useState("");
  const [responceMsg, setResponceMsg] = useState("");
  const [toasterType, setToasterType] = useState("");
  const [handleToaster, setHandleToaster] = useState(false);

  const [roleModalTrigger, setRoleModalTrigger] = useState(false);
  const [googleData, setGoogleData] = useState({});
  const [appleData, setAppleData] = useState({});
  const [facebookData, setFacebookData] = useState({});
  const [socialAccType, setSocialAccType] = useState("");
  const [signInLoader, setSignInLoader] = useState(false);
  const [isAskPassword, setIsAskPassword] = useState(false);
  const [isAuthenticate, setIsAuthenticate] = useState(false);
  const [signUpFlow, setSignUpFlow] = useState(false);
  const [loginFlow, setLoginFlow] = useState(false)
  const [isLoginApi, setIsLoginApi] = useState(false)
  const [isRoleSelected, setIsRoleSelected] = useState(false);
  const [wholeData, setWholeData] = useState({})
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const [signUpFlowNew, setSignUpFlowNew] = useState(false)

  const [feedbackMessage, setFeedbackMessage] = useState("")
  const [feedbackModal, setFeedbackModal] = useState(false);
  const [loginForMobileView, setLoginForMobileView] = useState(
    window.innerWidth < 768 ? true : false
  );

  const [isForOTP, setIsForOTP] = useState(false);

  const [toggleForMobileViewScreens, setToggleForMobileViewScreens] = useState(1);
  const [appLinkLoading, setAppLinkLoading] = useState(false);

  const [resendCodeTimer, setResendCodeTimer] = useState(60);
  const [resendCodeCheck, setResendCodeCheck] = useState(true);

  const [recievedCodeValue, setRecievedCodeValue] = useState("");
  const [isCodeError, setIsCodeError] = useState(false);
  const [OTPLoading, setOTPLoading] = useState(false);

  const [resendCodeLoading, setResendCodeLoading] = useState(false);

  const [appLink, setAppLink] = useState('https://play.google.com/store/apps/details?id=com.chilll.app');

  const baseURI = process.env.REACT_APP_MY_ENV.replace(/^https:\/\//, "");

  // Detect platform (iOS or Android)
  const userAgent = navigator.userAgent;
  const isAndroid = /android/i.test(userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(userAgent);


  useEffect(() => {
    function gettingTheAppLink() {
      let request_url = window.location.href

      const urlObj = new URL(request_url);
      urlObj.searchParams.set('page', 'login');
      request_url = urlObj.toString();

      // Encode the entire request URL
      const encodedRequestUrl = encodeURIComponent(request_url);



      // Construct app link based on platform
      const appLink = isAndroid
        ? `${baseURI}://deeplink?request_url=${encodedRequestUrl}` // Android app deep link
        : `${baseURI}://deeplink?request_url=${encodedRequestUrl}`; // iOS app deep link

      // Set the app link
      setAppLink(appLink);
    }
    gettingTheAppLink();
  }, []);

  const openInApp = (e) => {
    // Attempt to open the app link
    e?.preventDefault(); // Prevent default anchor behavior

    setAppLinkLoading(true);

    window.location.href = appLink; // Open the app link


    // Set a timeout to redirect to app stores if the app doesn't open (app not installed)
    const timeout = setTimeout(() => {

      // If app doesn't open, redirect to the Play Store or App Store
      if (isAndroid) {
        window.location.href = "https://play.google.com/store/apps/details?id=com.chilll.app";  // Redirect to Play Store if app not installed
      } else if (isIOS) {
        // window.location.href = "https://apps.apple.com/us/app/chilll/id1621747291";  // Redirect to App Store if app not installed
        // window.location.href = "https://apps.apple.com/us/app/apple-store/id1621747291";
        window.open("https://apps.apple.com/us/app/chilll/id1621747291", "_blank");
      } else {
        window.location.href = "https://play.google.com/store/apps/details?id=com.chilll.app";
      }
    }, 1500);  // 1.5 second timeout to check if app opens

    const id = setTimeout(() => {
      setAppLinkLoading(false);
      // isAndroid && alert('Something went wrong, please try after some time.');
    }, 4000);

    // clearTimeout(timeout); // Clear the timeout if the app is opened
  };

  let referalCode = "";

  if (urlParams.has('referalCode')) {

    referalCode = urlParams.get('referalCode')


  }

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const data = urlParams.get("valid");
    // console.log("data", data)
    if (data) {
      let details = {
        phone_code_id_int: 0,
        phone_number_int: 0,
        email_chr: "",
        password: "",
        fcm_token_chr: localStorage.getItem("fcm_token"),
        role_id_int: 0,
        guest_token_chr: data
      };
      dispatch(
        checkCredentials(
          details,
          (res) => handleAuthentication(res.data),
          (err) => {
            setPasswordErrorMsg("Invalid Credentials");

            if (err.data.default_password_ysn == 1) {
              localStorage.setItem("securityCode", err.data.security_code_chr);
              localStorage.setItem("get_countryCode", codeValue);
              localStorage.setItem("get_phonenumber", emailPhoneValue);
              navigate("/resetPassword");
            } else if (err.data.user_status == 0) {
              localStorage.setItem("receiverPlatform", emailPhoneValue);

              localStorage.setItem("countryCodeVal", codeValue);
              localStorage.setItem("emailPhoneVal", emailPhoneValue);
              // let data = {
              //   phone_code_id_int: parseInt(codeValue) || 1,
              //   phone_number_int: parseInt(emailPhoneValue),
              //   email_chr: "",
              //   voip_token_chr: ''
              // }

              let formData = new FormData();
              formData.append("phone_code_id_int", parseInt(codeValue));
              formData.append("phone_number_int", parseInt(emailPhoneValue));
              formData.append("email_chr", "");
              dispatch(
                resendCode(
                  formData,
                  (res) => { },
                  (err) => { }
                )
              );
              navigate("/activateUsers");
            } else {
            }
            setIsEmailPhoneVal(true);
            setIsPassword(true);
            setLoaderActive(false);

            setLoginErrorMsg(validEmail_OR_MobileNumberText);
          }
        )
      );
    }
  }, [])

  useEffect(() => {
    requestForToken();
  }, []);
  useEffect(() => {
    if (location.pathname == "/signup") {
      setSignUpFlow(true);
    }
    return () => {
      setSignUpFlow(false);
    };
    // console.log("Current route:", location.pathname);
  }, []);

  const handleAuthentication = (data) => {

    setLoaderActive(false);
    dispatch(authenticate());
    dispatch(setUserDetails(data));
    localStorage.setItem("access_token", data.access_token);
    localStorage.setItem("refresh_token", data.refresh_token);
    localStorage.setItem("user_id", data.user_id);
    localStorage.setItem("roleId", data.user_details.role_id_ids);
    localStorage.setItem(
      "fullName",
      data.user_details.first_name_chr + " " + data.user_details.last_name_chr
    );
    navigate("/dashboard", { replace: true });
  };

  const handleEmailPhone = (e) => {
    // console.log(e.target.value);
    setIsEmailPhoneVal(false);
    noSpaceOnChange(e.target.value) && setEmailPhoneValue(e.target.value);

  };

  const handleDropdownValue = (e) => {
    // setCodeValue(e.target.value);
    setCodeValue(e);

  };

  function handleBlur() {
    if (isPhone) {
      if (emailPhoneValue === "") {
        setIsEmailPhoneVal(true);
        setLoginErrorMsg(errEmptyEmailOrPhone);
      } else if (!phoneValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
        setLoginErrorMsg(validEmail_OR_MobileNumberText);
      }
    } else {
      if (emailPhoneValue === "") {
        setIsEmailPhoneVal(true);
        setLoginErrorMsg(errEmptyEmailOrPhone);
      } else if (!emailValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
        setLoginErrorMsg(validEmail_OR_MobileNumberText);
      }
    }
  }
  const handlePassword = (e) => {
    setIsPassword(false);
    setPassword(e.target.value);
  };
  const handleBlurPassword = () => {
    setIsFocused(false);
    if (!passwordValidation(password)) {
      setIsPassword(true);
      if (password === "") {
        setPasswordErrorMsg(errEmptyPassword);
      } else {
        setPasswordErrorMsg("Please enter a valid password");
      }
    }
  };
  useEffect(() => {
    const dot = ".";
    const leng = emailPhoneValue.length - 1;
    if (!isNaN(emailPhoneValue) && emailPhoneValue.charAt(leng) !== dot) {
      if (emailPhoneValue.length < 11) {
        setIsPhone(true);
      } else {
        setIsPhone(false);
      }
    } else {
      setIsPhone(false);
    }
    if (emailPhoneValue === "") {
      setIsPhone(false);
    }
  }, [emailPhoneValue]);

  const handleLoginValCheck = (e) => {

    e.preventDefault()
    if (loginFlow && isLoginApi) {
      handleLogin()
    } else {
      if (!isPhone) {
        if (emailValidation(emailPhoneValue)) {
          setLoaderActive(true);
          let details = new FormData();
          details.append("phone_code_id_int", 0);
          details.append("phone_number_int", 0);
          details.append("email_chr", emailPhoneValue);
          details.append("create_account_flag", 1);
          details.append("password_chr", password);
          // referalCode && details.append("referal_code_chr", referalCode);
          localStorage.getItem('referalCode') && details.append("referal_code_chr", localStorage.getItem('referalCode'));


          dispatch(
            accountExistenceCheckApi(
              details,
              (res) => {
                setWholeData(res.data)
                localStorage.setItem("emailPhoneVal", emailPhoneValue);
                if (!signUpFlowNew) {
                  if (res.data.compliance_account && res.data.account_exists) {
                    setIsAskPassword(res.data.account_exists);
                    setLoaderActive(false);
                    setLoginFlow(true)
                    setIsLoginApi(true)


                  } else {
                    setLoginErrorMsg("Invalid Email or Phone number");
                    setIsEmailPhoneVal(true);
                    setLoaderActive(false)
                  }
                }
                else {
                  if (!res.data.compliance_account && !res.data.account_exists) {
                    setResponceMsg(res.data.message);
                    setLoaderActive(false);
                    setToasterType("success");
                    setHandleToaster(true);

                    setTimeout(() => {
                      setHandleToaster(false);
                    }, 3000);
                    setIsAskPassword(true);
                  } else if (!res.data.compliance_account && res.data.account_exists) {
                    if (res.data.screen_number !== 0) {
                      localStorage.setItem("screen_number", res.data.screen_number)
                      localStorage.setItem("otp_chr", res.data.otp_chr)
                      localStorage.setItem("password", password)


                      setToasterType("success");
                      setHandleToaster(true);
                      setResponceMsg(res.data.message)
                      setTimeout(() => {
                        setLoaderActive(false);
                        setHandleToaster(false);
                        navigate("/signup")
                      }, 1000);
                    } else {
                      setIsAskPassword(res.data.account_exists);
                      setLoaderActive(false);
                      setLoginFlow(true)
                    }
                  } else {
                    setIsEmailPhoneVal(true);
                    setLoaderActive(false)
                    setLoginErrorMsg("Email already exist please login")
                  }
                }

                localStorage.getItem('referalCode') && localStorage.removeItem("referalCode");
              },
              (err) => {
                setLoaderActive(false);
              }
            )
          );
        } else {
          if (!emailValidation(emailPhoneValue)) {
            setIsEmailPhoneVal(true);
            if (emailPhoneValue === "") {
              setIsEmailPhoneVal(true);
              setLoginErrorMsg(errEmptyEmailOrPhone);
            } else if (!phoneValidation(emailPhoneValue)) {
              setIsEmailPhoneVal(true);
              setLoginErrorMsg(validEmail_OR_MobileNumberText);
            }
          }
        }
      } else {
        if (phoneValidation(emailPhoneValue)) {
          setLoaderActive(true);
          setIsEmailPhoneVal(false);
          let details = new FormData();
          details.append("phone_code_id_int", codeValue);
          details.append("phone_number_int", emailPhoneValue);
          details.append("email_chr", "");
          details.append("create_account_flag", 1);
          details.append("password_chr", password);
          // referalCode && details.append("referal_code_chr", referalCode);
          localStorage.getItem('referalCode') && details.append("referal_code_chr", localStorage.getItem('referalCode'));


          dispatch(
            accountExistenceCheckApi(
              details,
              (res) => {
                setWholeData(res.data)
                localStorage.setItem("countryCodeVal", codeValue);
                localStorage.setItem("emailPhoneVal", emailPhoneValue);
                if (!signUpFlowNew) {
                  if (res.data.compliance_account && res.data.account_exists) {
                    setIsAskPassword(res.data.account_exists);
                    setLoaderActive(false);
                    setLoginFlow(true)
                    setIsLoginApi(true)


                  } else {
                    setLoginErrorMsg("Invalid Email or Phone number");
                    setIsEmailPhoneVal(true);
                    setLoaderActive(false)
                  }
                }
                else {
                  if (!res.data.compliance_account && !res.data.account_exists) {
                    setResponceMsg(res.data.message);
                    setLoaderActive(false);
                    setToasterType("success");
                    setHandleToaster(true);

                    setTimeout(() => {
                      setHandleToaster(false);
                    }, 3000);
                    setIsAskPassword(true);
                  } else if (!res.data.compliance_account && res.data.account_exists) {
                    if (res.data.screen_number !== 0) {
                      localStorage.setItem("screen_number", res.data.screen_number)
                      localStorage.setItem("otp_chr", res.data.otp_chr)
                      localStorage.setItem("password", password)


                      setToasterType("success");
                      setHandleToaster(true);
                      setResponceMsg(res.data.message)
                      setTimeout(() => {
                        setLoaderActive(false);
                        setHandleToaster(false);
                        navigate("/signup")
                      }, 1000);
                    } else {
                      setIsAskPassword(res.data.account_exists);
                      setLoaderActive(false);
                      setLoginFlow(true)
                    }
                  } else {
                    setIsEmailPhoneVal(true)
                    setLoaderActive(false)
                    setLoginErrorMsg("Email already exist please login")
                  }
                }

                localStorage.getItem('referalCode') && localStorage.removeItem("referalCode");

              },
              (err) => {
                setLoaderActive(false);
              }
            )
          );
        } else {
          setIsEmailPhoneVal(true);

          if (emailPhoneValue === "") {
            setIsEmailPhoneVal(true);
            setLoginErrorMsg(errEmptyEmailOrPhone);
          } else if (!emailValidation(emailPhoneValue)) {
            setIsEmailPhoneVal(true);
            setLoginErrorMsg(validEmail_OR_MobileNumberText);
          }


        }
      }

    }
  };

  function handleLogin(e) {
    e?.preventDefault();

    if (isPhone) {
      if (password !== "") {
        setLoaderActive(true);
        let details = {
          phone_code_id_int: parseInt(codeValue) || 1,
          phone_number_int: parseInt(emailPhoneValue),
          email_chr: "",
          password: password,
          fcm_token_chr: localStorage.getItem("fcm_token"),
          role_id_int: localStorage.getItem("roleId") || 0,
        };
        dispatch(
          checkCredentials(
            details,
            (res) => handleAuthentication(res.data),
            (err) => {
              setPasswordErrorMsg("Invalid Credentials");

              if (err.data.default_password_ysn == 1) {
                localStorage.setItem("securityCode", err.data.security_code_chr);
                localStorage.setItem("get_countryCode", codeValue);
                localStorage.setItem("get_phonenumber", emailPhoneValue);
                navigate("/resetPassword");
              } else if (err.data.user_status == 0) {
                localStorage.setItem("receiverPlatform", emailPhoneValue);

                localStorage.setItem("countryCodeVal", codeValue);
                localStorage.setItem("emailPhoneVal", emailPhoneValue);
                // let data = {
                //   phone_code_id_int: parseInt(codeValue) || 1,
                //   phone_number_int: parseInt(emailPhoneValue),
                //   email_chr: "",
                //   voip_token_chr: ''
                // }

                let formData = new FormData();
                formData.append("phone_code_id_int", parseInt(codeValue));
                formData.append("phone_number_int", parseInt(emailPhoneValue));
                formData.append("email_chr", "");
                dispatch(
                  resendCode(
                    formData,
                    (res) => { },
                    (err) => { }
                  )
                );
                navigate("/activateUsers");
              } else {
              }
              setIsEmailPhoneVal(true);
              setIsPassword(true);
              setLoaderActive(false);

              setLoginErrorMsg(validEmail_OR_MobileNumberText);
            }
          )
        );
      } else {
        setIsPassword(true);
        setPasswordErrorMsg(errEmptyPassword);
      }


    } else {
      if (password !== "") {
        setLoaderActive(true);
        let details = {
          phone_code_id_int: null,
          phone_number_int: null,
          email_chr: emailPhoneValue,
          password: password,
          fcm_token_chr: localStorage.getItem("fcm_token"),
          voip_token_chr: "",
          role_id_int: localStorage.getItem("roleId") || 0,
        };
        dispatch(
          checkCredentials(
            details,
            (res) => handleAuthentication(res.data),
            (err) => {
              setPasswordErrorMsg("Invalid Credentials");

              if (err.data.default_password_ysn == 1) {
                localStorage.setItem("securityCode", err.data.security_code_chr);
                localStorage.setItem("get_email", emailPhoneValue);
                navigate("/resetPassword");
              } else if (err.data.user_status == 0) {
                localStorage.setItem("receiverPlatform", emailPhoneValue);

                localStorage.setItem("emailPhoneVal", emailPhoneValue);

                // let data = {
                //   phone_code_id_int: 0,
                //   phone_number_int: 0,
                //   email_chr: emailPhoneValue,
                // }

                let formData = new FormData();
                formData.append("phone_code_id_int", 0);
                formData.append("phone_number_int", 0);
                formData.append("email_chr", emailPhoneValue);
                dispatch(
                  resendCode(
                    formData,
                    (res) => { },
                    (err) => { }
                  )
                );
                navigate("/activateUsers");
              } else {
              }

              setIsEmailPhoneVal(true);
              setIsPassword(true);
              setLoaderActive(false);

              setLoginErrorMsg(validEmail_OR_MobileNumberText);

              // if (password === "") {
              //   setPasswordErrorMsg(validPassword)
              // } else {
              //   setPasswordErrorMsg(errEmptyPassword)
              // }
            }
          )
        );
      } else {
        setIsPassword(true);
        setPasswordErrorMsg(errEmptyPassword);
      }
    }
  }

  function handleMoveToSignUp() {
    navigate("/signup", { replace: true });
  }

  const handleShowRoleModal = () => {
    setRoleModalTrigger(true);
  };
  const handleCloseRoleModal = () => {
    setRoleModalTrigger(false);
  };

  // Social Account Singin using the Google account

  const handleGoogleSignin = (credentialResponseDecoded) => {
    // We have modified the flow for the getting the custom button for login
    // const credentialResponseDecoded = jwtDecode(credentialResponse.credential)
    // console.log(credentialResponseDecoded?.given_name, credentialResponseDecoded?.family_name, credentialResponseDecoded?.email, credentialResponseDecoded?.sub, "Finally Success")
    setSignInLoader(true);
    setGoogleData(credentialResponseDecoded);
    setSocialAccType("google");

    let details = new FormData();
    credentialResponseDecoded?.given_name &&
      details.append("first_name_chr", credentialResponseDecoded?.given_name);
    credentialResponseDecoded?.family_name &&
      details.append("last_name_chr", credentialResponseDecoded?.family_name);
    credentialResponseDecoded?.email &&
      details.append("email_chr", credentialResponseDecoded?.email);
    details.append("fcm_token_chr", localStorage.getItem("fcm_token"));
    credentialResponseDecoded?.sub &&
      details.append("social_id_chr", credentialResponseDecoded?.sub);
    details.append("social_account_type_chr", "google");

    dispatch(
      registerUserViaThirdPartyApp(
        details,
        (res) => {
          setSignInLoader(false);
          handleAuthentication(res.data);

        },
        (err) => {
          if (err.data.is_flag_role == 0) {
            handleShowRoleModal();

            dispatch(setIsSignUpFlagTrue());

          }
          setSignInLoader(false);

          if (err.data.is_flag_role != 0) {
            setResponceMsg(err.data.message);
            setToasterType("error");

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        }
      )
    );
  };

  const handleSocialSigninForNewUser = () => {
    if (!isRoleSelected) {
      return;
    }

    setLoaderActive(true);
    setSignInLoader(true);

    let details = new FormData();
    if (socialAccType === "google") {
      googleData?.given_name &&
        details.append("first_name_chr", googleData?.given_name);
      googleData?.family_name &&
        details.append("last_name_chr", googleData?.family_name);
      googleData?.email && details.append("email_chr", googleData?.email);
      details.append("fcm_token_chr", localStorage.getItem("fcm_token"));
      googleData?.sub && details.append("social_id_chr", googleData?.sub);
      details.append("social_account_type_chr", "google");
      details.append("role_id_int", parseInt(role));
    }

    if (socialAccType === "facebook") {
      facebookData?.first_name &&
        details.append("first_name_chr", facebookData?.first_name);
      facebookData?.last_name &&
        details.append("last_name_chr", facebookData?.last_name);
      facebookData?.email && details.append("email_chr", facebookData?.email);
      details.append("fcm_token_chr", localStorage.getItem("fcm_token"));
      facebookData?.userID &&
        details.append("social_id_chr", facebookData?.userID);
      details.append("social_account_type_chr", "facebook");
      details.append("role_id_int", parseInt(role));
    }

    if (socialAccType === "apple") {
      details.append(
        "first_name_chr",
        appleData?.firstName ? appleData?.firstName : "Chilll User"
      );
      appleData?.lastName &&
        details.append("last_name_chr", appleData?.lastName);
      appleData?.email && details.append("email_chr", appleData?.email);
      details.append("fcm_token_chr", localStorage.getItem("fcm_token"));
      appleData?.sub && details.append("social_id_chr", appleData?.sub);
      details.append("social_account_type_chr", "apple");
      details.append("role_id_int", parseInt(role));
    }

    dispatch(
      registerUserViaThirdPartyApp(
        details,
        (res) => {
          handleAuthentication(res.data);
          setLoaderActive(false);
          setSignInLoader(false);

          dispatch(setIsSignUpFlagTrue());
        },
        (err) => {
          setResponceMsg(err.data.message);
          setToasterType("error");
          setLoaderActive(false);
          setSignInLoader(false);

          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        }
      )
    );
  };

  const handleSocialSigninError = () => {
    setSignInLoader(false);
    setResponceMsg("Something went wrong, please try after some time.");
    setToasterType("error");

    setHandleToaster(true);
    setTimeout(() => {
      setHandleToaster(false);
    }, 11000);
  };

  const googleSigninCustom = useGoogleLogin({
    // flow: 'auth-code',
    onSuccess: async (tokenResponse) => {
      // console.log(tokenResponse);
      setSignInLoader(true);
      const userInfo = await axios
        .get("https://www.googleapis.com/oauth2/v3/userinfo", {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        })
        .then((res) => res.data);

      // console.log(userInfo);
      if (userInfo) {
        handleGoogleSignin(userInfo);
      }
    },
    onError: (error) => {
      setSignInLoader(true);
      // console.log("Login Failed:", error);
      handleSocialSigninError();
    },
  });

  // Social Account Singin using the Facebook account
  const handleFacebookSignin = (credentialResponseDecoded) => {
    // console.log(credentialResponseDecoded?.first_name, credentialResponseDecoded?.last_name, credentialResponseDecoded?.email, credentialResponseDecoded?.userID, "Finally Success")
    setSignInLoader(true);
    // console.log(credentialResponseDecoded);
    setFacebookData(credentialResponseDecoded);
    setSocialAccType("facebook");

    let details = new FormData();
    credentialResponseDecoded?.first_name &&
      details.append("first_name_chr", credentialResponseDecoded?.first_name);
    credentialResponseDecoded?.last_name &&
      details.append("last_name_chr", credentialResponseDecoded?.last_name);
    credentialResponseDecoded?.email &&
      details.append("email_chr", credentialResponseDecoded?.email);
    details.append("fcm_token_chr", localStorage.getItem("fcm_token"));
    credentialResponseDecoded?.userID &&
      details.append("social_id_chr", credentialResponseDecoded?.userID);
    details.append("social_account_type_chr", "facebook");

    dispatch(
      registerUserViaThirdPartyApp(
        details,
        (res) => {
          setSignInLoader(false);
          handleAuthentication(res.data);

        },
        (err) => {
          if (err.data.is_flag_role == 0) {
            handleShowRoleModal();

            dispatch(setIsSignUpFlagTrue());

          }
          setSignInLoader(false);

          if (err.data.is_flag_role != 0) {
            setResponceMsg(err.data.message);
            setToasterType("error");

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        }
      )
    );
  };

  const handleAppleSignin = (credentialResponse) => {
    const credentialResponseDecoded = jwtDecode(
      credentialResponse.authorization.id_token
    );
    // console.log(credentialResponseDecoded, "Finally Decoded Apple data comes here")

    setSignInLoader(true);
    setAppleData(credentialResponseDecoded);
    setSocialAccType("apple");

    let details = new FormData();
    details.append(
      "first_name_chr",
      credentialResponseDecoded?.firstName
        ? credentialResponseDecoded?.firstName
        : "Chilll User"
    );
    credentialResponseDecoded?.lastName &&
      details.append("last_name_chr", credentialResponseDecoded?.lastName);
    credentialResponseDecoded?.email &&
      details.append("email_chr", credentialResponseDecoded?.email);
    details.append("fcm_token_chr", localStorage.getItem("fcm_token"));
    credentialResponseDecoded?.sub &&
      details.append("social_id_chr", credentialResponseDecoded?.sub);
    details.append("social_account_type_chr", "apple");

    dispatch(
      registerUserViaThirdPartyApp(
        details,
        (res) => {
          setSignInLoader(false);
          handleAuthentication(res.data);
        },
        (err) => {
          if (err.data.is_flag_role == 0) {
            handleShowRoleModal();

            dispatch(setIsSignUpFlagTrue());

          }
          setSignInLoader(false);

          if (err.data.is_flag_role != 0) {
            setResponceMsg(err.data.message);
            setToasterType("error");

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        }
      )
    );
  };

  function changeMyMailOrPhone() {
    setIsAuthenticate(false);
  }

  const handleLoginCheck = (e, isOTP = false) => {
    e?.preventDefault();
    if (!isPhone) {
      if (emailValidation(emailPhoneValue)) {
        if (isOTP) {
          resendCodeActivation();
        } else {
          setIsAskPassword(true);
        }
      } else {
        if (!emailValidation(emailPhoneValue)) {
          setIsEmailPhoneVal(true);
          if (emailPhoneValue === "") {
            setIsEmailPhoneVal(true);
            setLoginErrorMsg(errEmptyEmailOrPhone);
          } else if (!phoneValidation(emailPhoneValue)) {
            setIsEmailPhoneVal(true);
            setLoginErrorMsg(validEmail_OR_MobileNumberText);
          }
        }
      }
    } else {
      if (phoneValidation(emailPhoneValue)) {
        setIsAskPassword(true);
        if (isOTP) {
          resendCodeActivation();
        }
      } else {
        setIsEmailPhoneVal(true);
        if (emailPhoneValue === "") {
          setIsEmailPhoneVal(true);
          setLoginErrorMsg(errEmptyEmailOrPhone);
        } else if (!emailValidation(emailPhoneValue)) {
          setIsEmailPhoneVal(true);
          setLoginErrorMsg(validEmail_OR_MobileNumberText);
        }
      }
    }
  }

  function handleFeedbackModal(type, message) {
    setFeedbackMessage(message)
    setFeedbackModal(false);
    // setHandleToaster(true);
    // setTimeout(() => {
    //     setHandleToaster(false);
    // }, 11000);
  }

  const resendCodeActivation = () => {
    if (phoneValidation(emailPhoneValue)) {
      setOTPLoading(true);
      setResendCodeLoading(true);
      let formData = new FormData();
      formData.append("phone_code_id_int", parseInt(codeValue) || 1);
      formData.append("phone_number_int", parseInt(emailPhoneValue));
      formData.append("email_chr", "");

      dispatch(
        resendCode(
          formData,
          (res) => {
            setIsAskPassword(true);
            setIsForOTP(true);
            setResponceMsg(res.data.message);
            setToasterType("success");
            // setHandleToaster(true);
            setOTPLoading(false);
            setResendCodeLoading(false);

            setResendCodeCheck(true);
            setResendCodeTimer(60);

            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          },
          (err) => {
            setResponceMsg(err.data.message);
            setToasterType("error");
            setHandleToaster(true);
            setOTPLoading(false);
            setResendCodeLoading(false);

            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        )
      );
    } else if (emailValidation(emailPhoneValue)) {
      setOTPLoading(true);
      setResendCodeLoading(true);
      let formData = new FormData();
      formData.append("phone_code_id_int", 0);
      formData.append("phone_number_int", 0);
      formData.append("email_chr", emailPhoneValue);

      dispatch(
        resendCode(
          formData,
          (res) => {
            setIsAskPassword(true);
            setIsForOTP(true);
            setOTPLoading(false);
            setResponceMsg(res.data.message);
            setToasterType("success");
            // setHandleToaster(true);
            setResendCodeLoading(false);
            setResendCodeCheck(true);
            setResendCodeTimer(60);

            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          },
          (err) => {
            setResponceMsg(err.data.message);
            setToasterType("error");
            setHandleToaster(true);
            setOTPLoading(false);
            setResendCodeLoading(false);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        )
      );
    }
  };

  function handleValidateCode(e) {
    setIsCodeError(false);
    setRecievedCodeValue(e.target.value);
  }

  function handleLoginViaOTP(e) {
    e?.preventDefault();

    if (isPhone) {
      if (recievedCodeValue !== "") {
        setLoaderActive(true);
        // let details = {
        //   phone_code_id_int: parseInt(codeValue) || 1,
        //   phone_number_int: parseInt(emailPhoneValue),
        //   email_chr: "",
        //   password: password,
        //   fcm_token_chr: localStorage.getItem("fcm_token"),
        //   role_id_int: localStorage.getItem("roleId") || 0,
        // };
        const details = new FormData();
        details.append("otp_chr", recievedCodeValue?.trim());
        details.append("phone_code_id_int", parseInt(codeValue) || 1);
        details.append("phone_number_int", parseInt(emailPhoneValue));
        details.append("email_chr", "");
        details.append("fcm_token_chr", localStorage.getItem("fcm_token"));

        dispatch(
          loginViaOTPApi(
            details,
            (res) => handleAuthentication(res.data),
            (err) => {
              setPasswordErrorMsg("Invalid Credentials");

              if (err.data.default_password_ysn == 1) {
                localStorage.setItem("securityCode", err.data.security_code_chr);
                localStorage.setItem("get_countryCode", codeValue);
                localStorage.setItem("get_phonenumber", emailPhoneValue);
                navigate("/resetPassword");
              } else if (err.data.user_status == 0) {
                localStorage.setItem("receiverPlatform", emailPhoneValue);

                localStorage.setItem("countryCodeVal", codeValue);
                localStorage.setItem("emailPhoneVal", emailPhoneValue);
                // let data = {
                //   phone_code_id_int: parseInt(codeValue) || 1,
                //   phone_number_int: parseInt(emailPhoneValue),
                //   email_chr: "",
                //   voip_token_chr: ''
                // }

                let formData = new FormData();
                formData.append("phone_code_id_int", parseInt(codeValue));
                formData.append("phone_number_int", parseInt(emailPhoneValue));
                formData.append("email_chr", "");
                dispatch(
                  resendCode(
                    formData,
                    (res) => { },
                    (err) => { }
                  )
                );
                navigate("/activateUsers");
              } else {
              }
              setIsEmailPhoneVal(true);
              // setIsPassword(true);
              setIsCodeError(true);
              setLoaderActive(false);

              setLoginErrorMsg(validEmail_OR_MobileNumberText);
            }
          )
        );
      } else {
        // setIsPassword(true);
        setIsCodeError(true);
        // setPasswordErrorMsg(errEmptyPassword);
      }


    } else {
      if (recievedCodeValue !== "") {
        setLoaderActive(true);
        // let details = {
        //   phone_code_id_int: null,
        //   phone_number_int: null,
        //   email_chr: emailPhoneValue,
        //   password: password,
        //   fcm_token_chr: localStorage.getItem("fcm_token"),
        //   voip_token_chr: "",
        //   role_id_int: localStorage.getItem("roleId") || 0,
        // };

        const details = new FormData();
        details.append("otp_chr", recievedCodeValue?.trim());
        // details.append("phone_code_id_int", parseInt(codeValue) || 1);
        // details.append("phone_number_int", parseInt(emailPhoneValue));
        details.append("email_chr", emailPhoneValue);
        details.append("fcm_token_chr", localStorage.getItem("fcm_token"));

        dispatch(
          loginViaOTPApi(
            details,
            (res) => handleAuthentication(res.data),
            (err) => {
              setPasswordErrorMsg("Invalid Credentials");

              if (err.data.default_password_ysn == 1) {
                localStorage.setItem("securityCode", err.data.security_code_chr);
                localStorage.setItem("get_email", emailPhoneValue);
                navigate("/resetPassword");
              } else if (err.data.user_status == 0) {
                localStorage.setItem("receiverPlatform", emailPhoneValue);

                localStorage.setItem("emailPhoneVal", emailPhoneValue);

                // let data = {
                //   phone_code_id_int: 0,
                //   phone_number_int: 0,
                //   email_chr: emailPhoneValue,
                // }

                let formData = new FormData();
                formData.append("phone_code_id_int", 0);
                formData.append("phone_number_int", 0);
                formData.append("email_chr", emailPhoneValue);
                dispatch(
                  resendCode(
                    formData,
                    (res) => { },
                    (err) => { }
                  )
                );
                navigate("/activateUsers");
              } else {
              }

              setIsEmailPhoneVal(true);
              // setIsPassword(true);
              setIsCodeError(true);
              setLoaderActive(false);

              setLoginErrorMsg(validEmail_OR_MobileNumberText);

              // if (password === "") {
              //   setPasswordErrorMsg(validPassword)
              // } else {
              //   setPasswordErrorMsg(errEmptyPassword)
              // }
            }
          )
        );
      } else {
        // setIsPassword(true);
        setIsCodeError(true);
        setPasswordErrorMsg(errEmptyPassword);
      }
    }
  }

  const intervalId = useRef(null);

  useEffect(() => {
    if (localStorage.getItem("emailPhoneVal") || true) {

      if (resendCodeCheck && resendCodeTimer > 0) {
        intervalId.current = setInterval(
          () => setResendCodeTimer((prev) => prev - 1),
          1000
        );
      } else if (!resendCodeCheck || resendCodeTimer === 0) {
        clearInterval(intervalId.current);
      }

      if (resendCodeTimer === 0) {
        setResendCodeCheck(false);
      }
      return () => clearInterval(intervalId.current);
    }

  }, [resendCodeCheck, resendCodeTimer]);

  return (
    <>
      {loginForMobileView ? (
        <>
          <div className="row m-0 p-0">
            <div
              className="col-12  d-flex cutome-col justify-content-center align-items-center overflow-auto"
              style={{ height: '100dvh' }}>

              <div className="sign-in-your mt-3 ">
                <div className="row d-flex justify-content-center">
                  <img
                    src={logo}
                    style={{ width: "108px", cursor: "pointer" }}
                    alt=""
                  />
                </div>

                {toggleForMobileViewScreens === 1 ? <>
                  <div className="row mt-3">
                    <span className="fs-3 font-w500 text-primary text-center" style={{}}>
                      {`When Something In Your Home Breaks`}
                    </span>
                  </div>

                  <div className="row mt-3">
                    <span className="fs-4 text-center text-black" style={{}}>{`Start Here`}</span>
                  </div>

                  <div className="row d-flex justify-content-center my-3 align-items-center">
                    <img
                      src={splashImg}
                      style={{ width: "260px", objectFit: "contain" }}
                      alt=""
                    />
                  </div>

                  <div className="col-12 d-flex justify-content-center align-items-center px-3 mb-3">
                    <span className="fs-4 text-center text-black" style={{}}>
                      {`Video chat with a pro - know what's wrong, what it should cost, and what to do next - `}
                      <span className="font-w600" style={{}}>{`FREE`}</span>
                    </span>
                  </div>


                  <div className="row">


                    <div className="col-12 p-0 mb-3 text-center d-flex justify-content-center align-items-center">
                      <PrimaryButton
                        buttonName={`GET STARTED`}
                        type={"submit"}
                        onClick={(e) => { setToggleForMobileViewScreens(2) }}
                        isLoading={loaderActive}
                        loadingMessage={"Loading..."}
                        style={{
                          width: "160px",
                          background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                          border: '2px solid rgba(255, 154, 32, 1)',
                          boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                        }}
                      />

                    </div>



                    {<div className="row">
                      <p className="terms-condition-link" style={{ textAlign: "center" }} onClick={() => {
                        setLoginForMobileView(false);
                      }}>
                        <span className="text-decoration-underline">
                          {`Log In`}
                        </span>
                      </p>

                    </div>}

                  </div>
                </> :
                  <>
                    <div className="row mt-3">
                      <span className="fs-4 text-center text-black" style={{}}>{`Hi.  Two different ways to get started`}</span>
                    </div>

                    <div className="row d-flex justify-content-center my-5 align-items-center">
                      <img
                        src={splashImg2}
                        style={{ width: "290px", objectFit: "contain", borderRadius: "8px 48px" }}
                        alt=""
                      />
                    </div>

                    <div className="col-12 p-0 mb-3 text-center d-flex justify-content-center align-items-center flex-column ">
                      <Button
                        style={{
                          width: "250px",
                          background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                          border: '2px solid rgba(255, 154, 32, 1)',
                          boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                          height: '65px',
                        }}
                        className="mb-3"
                        onClick={() => {
                          // setLoginForMobileView(false);
                          navigate("/signUpCustomer");
                        }}
                      >
                        <span>{`No Download`}</span>
                      </Button>

                      <Button
                        onClick={(e) => {
                          openInApp(e);
                        }}
                        disabled={appLinkLoading}
                        style={{
                          width: "250px",
                          background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                          border: '2px solid rgba(255, 154, 32, 1)',
                          boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                          height: '65px',
                        }}
                      >
                        <span>{`Download the Free App`}</span>  <br />
                        <span className="fs-7 text-black font-w600">More functionality</span>
                      </Button>
                    </div>
                  </>}



                {/* <div className="row mt-3">
                  <span className="terms-condition-link text-center"
                    onClick={() => {
                      setFeedbackModal(true);
                    }}
                  >
                    {`Give us feedback`}
                  </span>
                </div> */}
              </div>

            </div>
          </div>
        </>
      ) :
        <div className="">
          <div className="row  align-items-center justify-contain-center bg-login">
            <div className="col-xl-12 ">
              <div className=" border-0">
                <div className=" login-bx">
                  <div className="row custome-row">
                    <div
                      className="col-xl-6 col-md-6  text-center d-flex justify-content-center align-items-center"
                      style={{ height: '100dvh' }}>
                      <img src={outerMainBannerImg} alt="" style={{ width: "100%", height: '100%', objectFit: "cover" }} />
                    </div>
                    <div
                      className="col-xl-6 col-md-6  d-flex cutome-col justify-content-center align-items-center overflow-auto"
                      style={{ height: '100dvh' }}>
                      {!isAuthenticate ? (
                        <div className="sign-in-your mt-3">
                          <div className="row d-flex justify-content-center">
                            <img
                              src={logo}
                              style={{ width: "108px", cursor: "pointer" }}
                              alt=""
                            />
                          </div>

                          <div className="row mt-1">
                            <p className="login-subtitle">
                              <h1 className="mb-0" style={{ fontSize: "14px", fontWeight: "400", color: 'grey' }}>{txtANewWay}</h1>
                            </p>
                          </div>

                          {/* {isAskPassword && <div className="pointer text-hovered d-flex justify-content-center">
                          <i className="bi bi-arrow-left back-button-signup-icon pointer" onClick={() => {
                            setIsAskPassword(false);
                            setIsLoginApi(false)
                            setLoginFlow(false)
                            setPassword("");
                          }}></i>
                          <span onClick={() => {
                            setIsAskPassword(false);
                            setIsLoginApi(false)
                            setLoginFlow(false)
                            setPassword("");
                          }}>Back</span>
                        </div>} */}

                          <div className="row mt-3">
                            <span className="login-title" style={{ color: 'black' }}>
                              {isAskPassword ? txtWelcome : lblLoginTitle}

                              {/* {!isAskPassword && !loginFlow && lblSignUpIn}
                     {`${isAskPassword && wholeData?.account_exists && wholeData?.compliance_account ? "Welcome back "+wholeData?.data.user_name_chr +" !":""}`}
                     {isAskPassword && wholeData?.account_exists && !wholeData?.compliance_account && "Welcome to Chilll"}
                     {isAskPassword && !wholeData?.account_exists && !wholeData?.compliance_account && "Welcome to Chilll"} */}
                            </span>
                          </div>





                          {isAskPassword && (
                            <div className="row">
                              {!loginFlow && <span className=" justify-content-center">
                                <span className="textBeforeLogin fs-7">
                                  {isForOTP ? `Verification Code sent to` : lblSignInAs}
                                </span>

                                <span className="loginAs fs-6 " >{emailPhoneValue} &nbsp; <span
                                  className="fs-7 terms-condition-link d-flex align-items-center"
                                  onClick={() => {
                                    setIsAskPassword(false);
                                    setIsLoginApi(false)
                                    setLoginFlow(false)
                                    setPassword("");
                                    setIsForOTP(false);
                                  }}
                                >
                                  {`Not you?`}
                                </span></span>

                              </span>}
                            </div>
                          )}


                          {/* New flow for login */}
                          {!isAskPassword ?
                            <div className="row mt-2">
                              <EmailPhoneCombine
                                isEnteringNumber={isPhone}
                                setIsEnteringNumber={setIsPhone}
                                handleInputValue={handleEmailPhone}
                                handleChangeCode={handleDropdownValue}
                                errorOccured={isEmailPhoneVal}
                                inputValue={emailPhoneValue}
                                handleOnBlur={handleBlur}
                                defaultCodeValue={codeValue}
                                errorMessage={
                                  // validEmail_OR_MobileNumberText
                                  loginErrorMsg
                                }
                                autoF={true}
                                isRequired={true}
                              />

                              <div className="mb-2">
                                <PrimaryButton
                                  buttonName={"CONTINUE WITH PASSWORD"}
                                  onClick={(e) => {
                                    handleLoginCheck(e, false);
                                    setIsForOTP(false);
                                  }}
                                  isLoading={false}
                                  loadingMessage={"Loading..."}
                                  style={{
                                    width: "100%",
                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                    border: '2px solid rgba(255, 154, 32, 1)',
                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                    fontWeight: '600',
                                  }}
                                />
                              </div>

                              <div className="mb-2">
                                <PrimaryButton
                                  buttonName={"CONTINUE WITH OTP"}
                                  onClick={(e) => {
                                    handleLoginCheck(e, true);
                                  }}
                                  isLoading={OTPLoading}
                                  loadingMessage={"Loading..."}
                                  style={{
                                    width: "100%",
                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                    border: '2px solid rgba(255, 154, 32, 1)',
                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                    fontWeight: '600',
                                  }}
                                />
                              </div>
                            </div> :
                            <div className="row mt-2">
                              {isForOTP ?
                                <>
                                  <form onSubmit={(e) => { handleLoginViaOTP(e) }} autoComplete={false}>

                                    <div className="row">
                                      <InputField
                                        labelName={hintEnterValidationCode}
                                        placeholderName={hintEnterValidationCode}
                                        value={recievedCodeValue}
                                        onChange={handleValidateCode}
                                        errorOccured={isCodeError}
                                        errorMeesage={"Invalid code"}
                                        onBlur={() => { }}
                                        autoF={true}
                                      />
                                    </div>

                                    <PrimaryButton
                                      buttonName={'CONTINUE'}
                                      type={"submit"}
                                      onClick={(e) => { handleLoginViaOTP(e) }}
                                      isLoading={loaderActive}
                                      loadingMessage={"Loading..."}
                                      style={{
                                        width: "100%",
                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                        border: '2px solid rgba(255, 154, 32, 1)',
                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                      }}
                                    />
                                  </form>

                                  {resendCodeCheck && <div className="row mt-3  text-center">
                                    <span>
                                      {" "}
                                      Didn't receive the code? You can request a new code <br></br>to be
                                      sent in 00:
                                      {resendCodeTimer > 9 ? resendCodeTimer : "0" + resendCodeTimer}{" "}
                                    </span>
                                  </div>}

                                  <div className="row mt-3">
                                    <div className=" d-flex justify-content-center">
                                      {resendCodeLoading && <span className="me-2">
                                        <Spinner
                                          animation="border"
                                          role="status"
                                          size="sm"
                                          variant="primary"
                                        />
                                      </span>}
                                      <span
                                        onClick={resendCodeActivation}
                                        style={{
                                          color: "orange",
                                          fontWeight: "700",
                                          pointerEvents: resendCodeCheck ? "none" : "auto",
                                          opacity: resendCodeCheck ? "0.5" : "1",
                                          cursor: "pointer",
                                        }}>
                                        {btnResendCode}
                                      </span>
                                    </div>
                                  </div>

                                </> :
                                <>
                                  <form
                                    // onSubmit={handleLoginValCheck}
                                    onSubmit={(e) => { handleLogin(e) }}
                                  >
                                    <PasswordField
                                      onChange={handlePassword}
                                      inputValue={password}
                                      errorOccured={isPassword}
                                      errorMessage={passwordErrorMsg}
                                      labelName={lblPassword}
                                      // handleOnBlur={() => { !wholeData?.compliance_account && handleBlurPassword() }}
                                      onFocus={() => setIsFocused(true)}
                                      autoF={true}
                                    />

                                    <PrimaryButton
                                      buttonName={"LOG IN"}
                                      type={"submit"}
                                      onClick={(e) => { handleLogin(e) }}
                                      isLoading={loaderActive}
                                      loadingMessage={"Loading..."}
                                      style={{
                                        width: "100%",
                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                        border: '2px solid rgba(255, 154, 32, 1)',
                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                      }}
                                    />
                                  </form>
                                </>
                              }

                            </div>
                          }








                          <div className="row mt-2">
                            {false &&
                              <form
                                // onSubmit={handleLoginValCheck}
                                onSubmit={(e) => (!isAskPassword ? handleLoginCheck(e) : handleLogin(e))}
                              >
                                {!isAskPassword &&
                                  <EmailPhoneCombine
                                    isEnteringNumber={isPhone}
                                    setIsEnteringNumber={setIsPhone}
                                    handleInputValue={handleEmailPhone}
                                    handleChangeCode={handleDropdownValue}
                                    errorOccured={isEmailPhoneVal}
                                    inputValue={emailPhoneValue}
                                    handleOnBlur={handleBlur}
                                    defaultCodeValue={codeValue}
                                    errorMessage={
                                      // validEmail_OR_MobileNumberText
                                      loginErrorMsg
                                    }
                                    autoF={true}
                                    isRequired={true}
                                  />
                                }

                                {isAskPassword &&
                                  <PasswordField
                                    onChange={handlePassword}
                                    inputValue={password}
                                    errorOccured={isPassword}
                                    errorMessage={passwordErrorMsg}
                                    labelName={lblPassword}
                                    // handleOnBlur={() => { !wholeData?.compliance_account && handleBlurPassword() }}
                                    onFocus={() => setIsFocused(true)}
                                    autoF={true}
                                  />
                                }



                                <PrimaryButton
                                  buttonName={!isAskPassword ? "CONTINUE" : "LOG IN"}
                                  type={"submit"}
                                  onClick={(e) => { !isAskPassword ? handleLoginCheck(e) : handleLogin(e) }}
                                  isLoading={loaderActive}
                                  loadingMessage={"Loading..."}
                                  style={{
                                    width: "100%",
                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                    border: '2px solid rgba(255, 154, 32, 1)',
                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                  }}
                                />
                              </form>
                            }


                            {!signUpFlowNew && <div className="row mt-2">
                              <p className="terms-condition-link" style={{ textAlign: "center" }} onClick={() => {
                                navigate("/forgotPassword");
                              }}>
                                {txtForgotPassword}</p>

                            </div>}
                          </div>

                          {!isAskPassword && <>

                            <div className="separator-custom my-3">
                              <div
                                className="line-custom me-3"></div>
                              <span className="text-custom fs-6">{lblOr}</span>
                              <div
                                className="line-custom ms-3"></div>
                            </div>



                            <div className="row d-flex justify-content-center " style={{ pointerEvents: signInLoader ? 'none' : 'auto', opacity: signInLoader ? 0.5 : 1 }}>

                              {/* Google Signin custom Button for login */}
                              <div className="col-6 d-flex justify-content-center">
                                <div className="buttoncover">
                                  <Button
                                    className="signin-custom-btn mb-1"
                                    onClick={() => googleSigninCustom()}>
                                    <img
                                      src={googleIcon}
                                      alt=""
                                      style={{ maxWidth: "30px" }}
                                    />
                                    <span>{" GOOGLE"}</span>
                                    <span></span>
                                  </Button>
                                </div>
                              </div>

                              {/* Apple Signin custom Button for login */}
                              <div className="col-6 d-flex justify-content-center">
                                <div className="buttoncover">
                                  <LoginSocialApple
                                    client_id={process.env.REACT_APP_APPLE_ID || ""}
                                    scope={"name email"}
                                    redirect_uri={
                                      process.env.REACT_APP_REDIRECT_URL_FOR_APPLE
                                    }
                                    // onLoginStart={onLoginStart}
                                    onResolve={(response) => {
                                      // console.log(response);
                                      handleAppleSignin(response.data);
                                    }}
                                    onReject={(err) => {
                                      // console.log(err);
                                      // handleSocialSigninError();
                                    }}>
                                    {/* <AppleLoginButton className="signin-custom-btn" /> */}
                                    <Button className="signin-custom-btn ">
                                      <img
                                        src={appleIcon}
                                        alt=""
                                        style={{ maxWidth: "30px" }}
                                      />
                                      <span>{" APPLE"}</span>
                                      <span></span>
                                    </Button>
                                  </LoginSocialApple>
                                </div>
                              </div>
                            </div>
                          </>}

                          {/* {!isAskPassword && <div className="separator-custom my-3">
                          <div
                            className="line-custom me-3"></div>
                          <span className="text-custom fs-6">{!signUpFlowNew ? btnNotUser : "Already have an account?"}</span>
                          <div
                            className="line-custom ms-3"></div>
                        </div>} */}


                          {/* {!isAskPassword && <PrimaryButton
                          buttonName={signUpFlowNew ? "Login" : "Sign Up"}
                          loadingMessage={"Loading..."}
                          style={{
                            width: "100%",
                            background: '#fff',
                            border: '1px solid rgb(199, 212, 234) ',
                            boxShadow: '0px 6px 12px 0px rgba(102, 129, 172, 0.12)',
                            color: "black",
                            fontWeight: 600
                          }}
                          onClick={() => {
                            setEmailPhoneValue("")
                            setIsEmailPhoneVal(false)
                            setSignUpFlowNew(!signUpFlowNew)
                          }}
                        />
                        } */}

                          {/* {!isAskPassword && <PrimaryButton
                          buttonName={btnSignUp}
                          loadingMessage={"Loading..."}
                          style={{
                            width: "100%",
                            background: '#fff',
                            border: '1px solid rgb(199, 212, 234) ',
                            boxShadow: '0px 6px 12px 0px rgba(102, 129, 172, 0.12)',
                            color: "black",
                            fontWeight: 600
                          }}
                          onClick={() => {
                            navigate("/signup");
                          }}
                        />} */}

                          {!isAskPassword &&
                            <div className="row mt-3">
                              <div
                                className="col-12 d-flex justify-content-center align-items-center text-center"
                                style={{ fontSize: '14px' }}
                              >
                                <span className="me-1">{`Don't have a Chilll account? `}</span>
                                <span className="terms-condition-link text-center text-primary"
                                  onClick={() => {
                                    navigate("/signup");
                                  }}
                                >
                                  {`Sign Up`}
                                </span>
                              </div>
                            </div>
                          }

                          <div className="row mt-3">
                            <span className="terms-condition-link text-center"
                              onClick={() => {
                                setFeedbackModal(true);
                              }}
                            >
                              {`Give us feedback`}
                            </span>
                          </div>



                          {isAskPassword && signUpFlowNew && <div className="row mt-5">
                            <p style={{ textAlign: "center", color: 'black', fontWeight: 600 }}>
                              By continuing, you agree to Chilll<br></br>
                              <div className="">
                                <a
                                  className="terms-condition-link"
                                  href="https://chilll.com/chilll-terms-conditions/"
                                  target="_blank"
                                  rel="noreferrer">
                                  {"Terms of Service "}
                                </a>
                                <span style={{ color: 'black', fontWeight: 600 }}>and</span>
                                <a
                                  className="terms-condition-link"
                                  href="https://chilll.com/privacy-policy/"
                                  target="_blank"
                                  rel="noreferrer">
                                  {" Privacy Policy"}
                                </a>
                              </div>
                            </p>
                          </div>}
                        </div>
                      ) : (
                        <VerifyComponent
                          hanldleChangeMyMailOrPhone={changeMyMailOrPhone}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      {/* Modal for the confirmation from the user to select role type */}
      <>
        <Modal
          className="fade"
          show={roleModalTrigger}
          // onHide={handleClose}
          centered
        >
          {/* <Modal.Header style={{ borderBottom: "none" }}>
            <Modal.Title>{txtSignUpAs}</Modal.Title>
            <Button
              variant=""
              className="btn-close btn-close-service"
              onClick={() => handleCloseRoleModal()}
            />
          </Modal.Header> */}

          <Modal.Body>

            <div className='row mx-0'>
              <div className='col-12 px-0'>

                <>
                  <div className='mx-0 row'>
                    <div className='col-12 d-flex fs-4 justify-content-end px-0 text-black'>
                      <span onClick={() => handleCloseRoleModal()} className='cursor-pointer'>
                        <i className="bi bi-x-lg"></i>
                      </span>
                    </div>
                  </div>

                  <div className='mx-0 row mb-4'>
                    <div className='col-12 font-w600 fs-3 px-0 text-center text-black '>
                      <span>
                        {/* {txtSignUpAs} */}
                        {`Choose your role`}
                      </span>
                    </div>
                  </div>




                  <div className="row">
                    <div
                      onClick={() => {
                        setRole("2");
                        setIsRoleSelected(true);
                      }}
                      className="signUp-role-select rounded-2 shadow-lg px-3 bg-white"
                      style={{
                        cursor: "pointer",
                        // background: role === "2" ? "#ffa50029" : "white",
                        border:
                          role === "2"
                            ? "2px solid #fc8019"
                            : "1px solid lightgrey",
                      }}
                    >
                      <div className="pe-3">
                        <input
                          className="form-check-input"
                          style={{ display: 'inline-block' }}
                          name="selectRole"
                          type="radio"
                          value={`2`}
                          onChange={(e) => { setRole("2") }}
                          checked={role == "2"}
                        />
                      </div>
                      {/* <div className="signUp-role-img-container">
                          <img
                            style={{ marginLeft: "5px", objectFit: "cover", width: '100%' }}
                            src={customerImg}
                            alt=""
                          />
                        </div> */}

                      <div className="position-relative" style={{ width: '75px' }}>
                        <img
                          className="position-absolute"
                          style={{ width: '65px', bottom: '-40px' }}
                          src={customerImg}
                          alt=""
                        />
                      </div>

                      <div className="d-flex flex-column">
                        <span
                          style={{
                            fontWeight: "600",
                            fontSize: "14px",
                            color: "black",
                          }}>
                          {"I’m a customer"}
                        </span>
                        <span style={{ fontSize: "12px" }}>
                          {"I need things fixed"}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div
                      onClick={() => {
                        setRole("1");
                        setIsRoleSelected(true);
                      }}
                      className="signUp-role-select rounded-2 shadow-lg px-3 bg-white"
                      style={{
                        cursor: "pointer",
                        // background: role === "1" ? "#ffa50029" : "white",
                        border:
                          role === "1"
                            ? "2px solid #fc8019"
                            : "1px solid lightgrey",
                      }}>

                      <div className="pe-3">
                        <input
                          className="form-check-input"
                          style={{ display: 'inline-block' }}
                          name="selectRole"
                          type="radio"
                          value={`1`}
                          onChange={(e) => { setRole("1") }}
                          checked={role == "1"}
                        />
                      </div>

                      {/* <div className="signUp-role-img-container">
                          <img style={{}} src={proIcon} alt="" />
                        </div> */}

                      <div className="position-relative" style={{ width: '75px' }}>
                        <img
                          className="position-absolute"
                          style={{ width: '65px', bottom: '-40px' }}
                          src={proImg}
                          alt=""
                        />
                      </div>

                      <div className="d-flex flex-column">
                        <span
                          style={{
                            fontWeight: "600",
                            fontSize: "14px",
                            color: "black",
                          }}>
                          {"I’m a Pro"}
                        </span>
                        <span style={{ fontSize: "12px" }}>
                          {"I fix things"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* <div className="row">
                    <div
                      className="signUp-role-select rounded-2 shadow-lg px-3 bg-white"
                      style={{
                        opacity: "0.5",
                        pointerEvents: 'none',
                        border:
                          role === "3"
                            ? "2px solid #fc8019"
                            : "1px solid lightgrey",
                      }}
                    >
                      <div className="pe-3">
                        <input
                          className="form-check-input"
                          style={{ display: 'inline-block' }}
                          name="selectRole"
                          type="radio"
                          value={`3`}
                          onChange={(e) => { setRole("3") }}
                          checked={role == "3"}
                        />
                      </div>

                      <div className="position-relative" style={{ width: '75px' }}>
                        <img
                          className="position-absolute"
                          style={{ width: '65px', bottom: '-40px' }}
                          src={proTeamImg}
                          alt=""
                        />
                      </div>

                      <div className="d-flex flex-column">
                        <span
                          style={{
                            fontWeight: "600",
                            fontSize: "14px",
                            color: "black",
                          }}>
                          {"We’re a Pro team"}
                        </span>
                        <span style={{ fontSize: "12px" }}>
                          {"We fix things"}
                        </span>
                      </div>
                    </div>
                  </div> */}





                  {!isRoleSelected && (
                    <div className="row">
                      <p style={{ color: "red", marginBottom: "0px" }}>
                        {"Please select your role"}
                      </p>
                    </div>
                  )}


                  <div className='row mx-0 justify-content-between mt-2'>


                    <div className='col-12 px-0 mb-2'>
                      <PrimaryButton
                        buttonName={"GET STARTED"}
                        onClick={() => {
                          handleSocialSigninForNewUser()


                          // Updated the signup for the Pro again as before
                          // if (role == 1) {
                          //   navigate("/signUpPro");
                          // } else {
                          //   handleSocialSigninForNewUser()
                          // }
                        }}
                        type={"submit"}
                        isLoading={loaderActive}
                        loadingMessage={"Loading..."}
                        style={{
                          width: '100%',
                          background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                          border: '2px solid rgba(255, 154, 32, 1)',
                          boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                        }}
                      />
                    </div>

                  </div>


                </>



              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>

      {feedbackModal && (
        <FeedbackModal
          addUserTrigger={feedbackModal}
          handleCloseAddUser={handleFeedbackModal}
        />
      )}

      {handleToaster && (
        <ResponceToaster toasterType={toasterType} message={responceMsg} />
      )}
    </>
  );
}
